/* eslint-disable react-hooks/rules-of-hooks */

import { useRouter } from 'next/router';
import { AD_UNIT_SECTION } from '../types';

// getPageSectionForAdUnit is used to find the section of website and return a valid advertising ad unit 'section'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPageSectionForAdUnit = (mapping: any): AD_UNIT_SECTION => {
    const router = useRouter();
    const { route } = router;

    const page = Object.entries(mapping).find((k) => route.startsWith(k[0]));

    if (page === undefined) {
        return AD_UNIT_SECTION.UNKNOWN;
    }

    return <AD_UNIT_SECTION>page[1];
};
